import { submitFetch } from './common'
import imagesLoaded from 'imagesloaded'
import anime from 'animejs/lib/anime.es.js';
import summaryItem from '@/html/summary-item.html';

const setSummaryAction = () => {
    return new Promise((resolve, reject) => {
        const appendedObject = $('#top_summary .items')
        const appendHtmlBase = summaryItem

        $('#top_summary .sort > *').on('click', (e, callback) => {
            let morelink
            appendedObject.empty().removeClass('none')
            const type = $(e.currentTarget).attr('data-type')
            $(e.currentTarget).parent().attr('data-type', type)
            switch (type) {
                case 'newest':
                    morelink = '/search?sort=newest'
                    break
                case 'popular':
                    morelink = '/search?sort=view'
                    break
            }
            $('#top_summary a.button').attr('href', morelink)

            submitFetch(`/api/product/summary/${type}`, 'GET')
                .then(resp => {
                    if (!resp.products.length) {
                        appendedObject
                            .append($('<p>').addClass('none').text('コンテンツがありません。'))
                            .addClass('none')
                        return
                    }
                    resp.products.forEach(_obj => {
                        let tmpl = $(appendHtmlBase)
                        const userPic = 'picture' in _obj.user.user_profile && 'path' in _obj.user.user_profile.picture ? `/thumb/path/icon_profile/${_obj.user.user_profile.picture.path}` : '/assets/img/user_default.jpg'
                        tmpl.attr('href', `/item/${_obj.id}`)
                        tmpl.find('.thumbnail img').attr('src', _obj.video_banner_h)
                        tmpl.find('.thumbnail figcaption').text(_obj.title)
                        tmpl.find('.user-profile img').attr('src', userPic)
                        tmpl.find('.user-profile .name').text(_obj.user.name)
                        appendedObject.append(tmpl)
                    })
                    if (typeof callback === "function") callback()
                })
            $(e.currentTarget).siblings().removeClass('selected')
                .end()
                .addClass('selected')
        })

        $('#top_summary .sort .selected').trigger('click', () => {
            resolve()
        })
    })
}

const setMenuFixed = () => {
    let headerObj = $('#main-header')
    let sortObj = $('#top_summary')
    let positionCurrent = 0
    let sortFixedFlg = false
    let sortPosStart = sortObj.position().top
    let sortPosEnd = sortPosStart + sortObj.outerHeight() - 55
    console.log(sortObj.outerHeight())
    headerObj.removeClass('sortFixed')

    $(window).on('scroll.header', e => {
        positionCurrent = $(window).scrollTop()
        if (positionCurrent > sortPosStart && positionCurrent < sortPosEnd) {
            if (!sortFixedFlg) {
                headerObj.addClass('sortFixed')
                sortFixedFlg = true
            }
        } else {
            if (sortFixedFlg) {
                headerObj.removeClass('sortFixed')
                sortFixedFlg = false
            }
        }
    })
}

const main = () => {
    if (!document.querySelector('#page-home')) return

    setSummaryAction()
        .then(() => {
            imagesLoaded(document.querySelector('main'), () => {
                console.log("load")
                setMenuFixed()
            })
        })

    anime({
        targets: '#videolist-cursor',
        translateY: 10,
        loop: true,
        easing: 'easeInOutSine'
    });
}
export default main